import React, { useState } from "react";
import { RiCloseLine } from "react-icons/ri";
import NewPrescription from "../../../prescription/NewPrescription"
import Drugs from "../../../prescription/Forms/Drugs";

const AddPrescription = ({ onClose, details, edit }) => {
  const [formData, setFormData] = useState([])
  const [neDrugs, setNewDrugs] = useState([])
  const [currStage, setCurrStage] = useState(1)
  const updateFormData = (newData) => {
    setNewDrugs(newData)
  };

  return (
    <>
      <dialog >
        <div className="w-[600px] flex flex-col overflow-hidden bg-white rounded-md border relative">
          <section className="font-euclid-circular-a w-full relative">
            <div className="w-full bg-primary rounded-t-md" >
              <div className="flex justify-between w-full align-middle">
                <h2 className="text-white text-xl font-semibold leading-7 tracking-wide p-8">
                  {
                    !edit ? 'Create Prescription' : 'Edit Prescription'
                  }
                </h2>
                <div className="leading-7 text-xl font-semibold">
                  <button onClick={onClose}> <RiCloseLine color="white" size={30} /> </button>
                </div>
              </div>
            </div>
          </section>
          <section className="font-euclid-circular-a w-full h-[750px] overflow-hidden overflow-y-auto">
            <NewPrescription stage={1} mode={'direct'} userDetails={details} noTopnav={true} update={() => onClose()} />
          </section>
        </div>
      </dialog>
    </>
  );
};

export default AddPrescription;
